import styled from 'styled-components'

export const Title = styled.div`
top: -4vh;
position: absolute;
width: 55vw;
height: auto;
display: flex;
align-items: center;
padding: 30px;
font-family: Michroma;
letter-spacing: 1vw;
font-weight: bold;
margin-left: ${({left}) => left ? 'inherit' : 'auto'};
${({left}) => left ? 'right: 0;' : 'justify-content: flex-end;'};
color: #fff;

background-color: ${({bg_color}) => bg_color};
font-family: 'Roboto';
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
line-height: 1.2;
border-radius: 50px;
padding: 10px 3vw;



@media screen and (max-width: 1000px) {
    font-size: 5vw;
    top: -6vh;
}

`

export const TitleWrapper = styled.div`
margin-top: 20vh;
width: 100%;
${({solo}) => solo===true ? '' : 'background-color: #363636; height: 40vh;'}

position: relative;
@media screen and (max-width: 1000px) {
    height: auto;
    padding-bottom: 40px;
}

`

export const DescWrapper = styled.div`
padding-top: 10vh;
padding-right: 15vw;
padding-left: 15vw;

`

export const DescriptionText = styled.p`
font-size: ${({size}) => (size==='') ? 'inherit' : size};

@media screen and (max-width: 786px) {
    font-size: 12px;
}
`
